import axios from 'axios';
import { apiAdminUrl } from '../../constants';

const userSettings = (userId) => {
  return axios.get(apiAdminUrl + '/userSettings?id=' + userId);
};

export default userSettings;
